import React, {FC} from 'react'
import { Grid, Segment } from 'semantic-ui-react'
import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { LKHeader } from 'loankeeper-common/components'
//@ts-ignore
import { Container, FakeInput, GridContainer, SegmentGroup } from 'shared/StyledComponents'
import { translateLabel, translateBase, icon } from '../helpers'
import { ClientDetailsData } from '../types'
const PhysicalFirst: FC<{
  data: ClientDetailsData
}> = (props) => { 
  const { data } = props
  return(
  <Container>
    <SegmentGroup>
      <Segment.Group>
        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">
                  <LKHeader size="small">{translateLabel('fullname_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column style={{ width: '33.33333334%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>
                          {data.FullName} {data.FathersName}
                        </strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.FullName_ALT}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">
                  <LKHeader size="small">{translateLabel('regdate')}</LKHeader>
                </Grid.Column>
                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{LKDate.from(data.RegDate).toString()}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('dob_t')}</Grid.Column>

                <Grid.Column>
                  <GridContainer style={{ margin: '-5px' }}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={8}>
                          <FakeInput>
                            <Segment>
                              <LKHeader size="small">{LKDate.from(data.DOB).toString()}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>

                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateLabel('age_t')}
                        </Grid.Column>

                        <Grid.Column width={4}>
                          <FakeInput>
                            <Segment>
                              <LKHeader size="small">{moment().diff(data.DOB, 'years')}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </GridContainer>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('birthplace_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BirthPlace}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('birthcountry_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BirthCountry}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('idcardtype_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.IDCardType}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('idcardissuer_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.IDCardIssuer}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('gender_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Sex}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">
                  <LKHeader size="tiny">{translateLabel('idcardnumber_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.CardNumber}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('id_issue_date_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{LKDate.from(data.IDCardRegDate).toString()}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('resident_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Resident}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('idcardserial_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.IDSerial}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('id_validity_date_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{LKDate.from(data.IDValidityDate).toString()}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('idp_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.IDP}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('address1_t')}</Grid.Column>

                <Grid.Column style={{ width: '50.00000001%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {`${data.Address}, ${data.City}, ${data.Territory}, ${data.Region}, ${data.Country}`}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('phone_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Phone}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">
                  <LKHeader size="small">{translateLabel('address2_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column style={{ width: '50.00000001%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>
                          {`${data.Address2}, ${data.City2}, ${data.Territory2}, ${data.Region2}, ${data.Country2}`}
                        </strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">
                  <LKHeader size="tiny">{translateLabel('cell_phone_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.CellPhone}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('address3_t')}</Grid.Column>

                <Grid.Column style={{ width: '50.00000001%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {`${data.AddressBus}, ${data.ZoneBus}, ${data.DistrictBus}, ${data.CityBus}, ${data.TerritoryBus}, ${data.RegionBus}, ${data.CountryBus}`}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('email1_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Email}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('address_details_t')}</Grid.Column>

                <Grid.Column style={{ width: '50.00000001%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {/* @ts-ignore */}
                        {`${data.ZipCodeBus} / ${parseInt(data.DistanceBus, 10)} / ${data.UrbanBus}`}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('email2_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      {/* @ts-ignore */}
                      <LKHeader.Oneline size="small">{data.Email1}</LKHeader.Oneline>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('ind_risklevel_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.RiskLevel}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('insider_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Insider}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('english_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.EnglishKnowledge}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">
                  <LKHeader size="tiny">{translateLabel('client_number')}</LKHeader>
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.CustomNum}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('read_write_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ReadingSkills}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('author')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AuthorLoginFull}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('ref')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Referral}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column style={{ width: '33.33333334%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ReferralNote}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('client_watch_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.LoanOfficer}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('industry_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Industry}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('industry_sub_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      {/* @ts-ignore */}
                      <LKHeader.Oneline size="small">{`${data.SubIndustry} / ${data.IndustrySubDetail}`}</LKHeader.Oneline>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('registered_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.RegisteredBusiness}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('busness_type_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BusinessType}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('mobility_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.StaticBusiness}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" style={{ whiteSpace: 'norwap' }}>
                  {translateLabel('licence_no_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.LicenseCardNumber}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translateLabel('amlstatus_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AMLStatus}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right">{translateLabel('amlsuspicious_t')}</Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AMLSuspicious}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" style={{ whiteSpace: 'norwap' }}>
                  {translateLabel('smssignflag_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.SMSSign}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </Segment.Group>
    </SegmentGroup>
  </Container>
)}

(PhysicalFirst as any).config = {
  title: () => translateBase('tb_ind_1'),
  name: 'general',
  component: PhysicalFirst,
  api: 'base',
  icon: icon('tb_ind_1'),
}


export default PhysicalFirst
